import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { AboutUsHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/about-us/about-us-hero-section';
import { AboutUsContent } from '@trashlab/sitesapp/src/templates/redebins/components/about-us/about-us-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const AboutUsPage = () => {
  return (
    <>
      <AboutUsHeroSection />
      <AboutUsContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/about-us',
  component: AboutUsPage,
});

